/* Widget della geolocalizzazione.
Utilizza il modulo locate control di Leaflet */

import { useLeaflet } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";
import "leaflet.locatecontrol";
import icon from './locate-icon.svg'

const Location = (props) => {
    const { map } = useLeaflet();
    useEffect(() => {
        let locate = L.control.locate({
            position: 'topright',
            setView: false, 
            showCompass: true,
            icon: "leaflet-control-locate-location-arrow",
            onLocationError: function(err) {},  
            clickBehavior: {inView: 'setView', outOfView: 'setView', inViewNotFollowing: 'setView'}    

        }).addTo(map);
        
        locate.start();
    },[]);
    return null;
};

export default  (Location);